import moment from "moment";
import momentTimezone from 'moment-timezone';
import { currencies } from "../../../constants/currencies";

export const getInitialStatisticValues = (
  data,
  eventTimeZone,
  eventCurrency,
  startDate = null,
  endDate = null,
) => {
  const timeZone = +momentTimezone().tz(eventTimeZone).format('Z').slice(0, 3) || 0;
  const currency = currencies.find(
      item => item.value === eventCurrency
    ).label;

  const dataWithEventTimezone = data.map((tr) => {
    return {
      ...tr,
      paymentDate: moment(tr.paymentDate).utcOffset(0, true).add("h", timeZone).toISOString(),
    }
  });

  let firstPaymentDate = dataWithEventTimezone.at(-1).paymentDate;

  if (startDate) {
    firstPaymentDate = startDate;
  }
  const today =
    moment()
    .utc()
    .add("h", timeZone)
    .toISOString();

  const periodStart =
    moment(firstPaymentDate)
    .startOf('day')
    .toISOString();

  return {
    dataWithEventTimezone,
    periodStart,
    periodEnd: endDate || today,
    timeZone,
    minDate: firstPaymentDate,
    maxDate: today,
    currency,
  };
}
